import { useState } from "react";

import iBack from "../../../assets/images/100-back.svg";
import iCircleBlue from "../../../assets/images/100-circle-blue.svg";
import iDot from "../../../assets/images/100-circle-gray.svg";
import iPin from "../../../assets/images/100-pin.svg";
import iReply from "../../../assets/images/100-reply.svg";
import avatar4 from "../../../assets/images/avatar2.png";
import screenImg2 from "../../../assets/images/os-screen.png";
import screenImg from "../../../assets/images/step-thumb-1.png";
import ToggleButton from "../../../components/ToggleButton";
import SingleScreen from "../../../components/side-tabs/SingleScreen";
import { useGlobal } from "../../../contexts/globalContext";

export default function SideTabs({ loading }) {
  const { SCREEN_STATE } = useGlobal();
  const [tab, setTab] = useState("listScreens");
  const [showReply, setShowReply] = useState();

  return (
    <div className="">
      <div className="sidebar-player-mode m-t-0">
        {loading ? (
          <div className="loadingPage-sidebar-tab">
            <div className="loading-75-20-25 loading-animation" />
            <div className="loading-75-20-25 loading-animation" />
            <div className="loading-75-20-25 loading-animation" />
          </div>
        ) : (
          <div className="sidebar-tab-title B3-Medium">
            <ul>
              <li className={tab === "listScreens" ? "active-tab" : undefined} onClick={() => setTab("listScreens")}>
                Screens
                <span className={`circle-count C1-SemiBold i-18 ${tab === "comments" && "gray"}`}>
                  {SCREEN_STATE.screens.filter((x) => !x.is_base && x.rewind_screen_id > 0).length}
                </span>
              </li>
              <li className={tab === "comments" ? "active-tab" : undefined} onClick={() => setTab("comments")}>
                Comments <span className="circle-count C1-SemiBold i-18 blue">1</span>
              </li>
            </ul>
          </div>
        )}
        {loading ? (
          <div className="loadingPage-sidebar-content">
            {Array.from(Array(3), (_, i) => (
              <div key={i} className="flex m-tb-20">
                <div className="loading-75-46-5 loading-animation" />
                <div className="flex-col m-l-10">
                  <div className="loading-75-20-25 loading-animation m-b-5" />
                  <div className="loading-50-20-25 loading-animation" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="sidebar-tab-content">
            {tab === "listScreens" && (
              <>
                {/* {SCREEN_STATE.screens
                  .filter((x) => !x.is_base && x.rewind_screen_id > 0)
                  .map((screen, index) => {
                    return (
                      <div
                        key={index}
                        className={`sidebar-tab-screen ${index + 1 === 1 ? "active" : null}`}>
                        <div
                          className={`sidebar-tab-screen-img ${
                            !screen.like && "screen-power-off"
                          } `}>
                          <Video
                            style={{ borderRadius: 0, width: "100%" }}
                            srcObject={getMediaStream(screen)}
                          />
                        </div>
                        <span
                          className={`screen-power-state ${serverError ? "server-error" : null}`}>
                          {
                            <img alt=""
                              src={screen.like ? screenOn : screenOff}
                              className={screen.like ? "hide" : null}
                              onClick={() => serverErrorHandler()}
                            />
                          }
                        </span>
                        <div className="screen-info-strip" />
                        <div className="screen-info">
                          <div className="align-items-center space-between p-10 h-100p">
                            <div className="flex">
                              <span className="screen-info-os">
                                <img alt="" src={osWin} className="btn-os-win m-r-5" width={20} />
                                <span className="tooltip-type2">{screen.os}</span>
                              </span>
                              <span className="screen-title">{screen.description}</span>
                            </div>
                            <div className="screen-participants">
                              <img alt="" src={avatar1} />
                              <img alt="" src={avatar1} />
                              <img alt="" src={avatar1} />
                              <span className="bold"> +12 </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })} */}
                <div className="list-screens">
                  <SingleScreen img={screenImg} os="mac" name="macOS fresh" />
                  <SingleScreen img={screenImg2} isMobile os="ios" name="macOS fresh" />
                </div>
              </>
            )}

            {tab === "comments" && (
              <>
                <div className="h-36 m-tb-16 align-center">
                  <div className="align-center">
                    {showReply ? (
                      <>
                        <img alt="" src={iBack} width={36} height={36} className="pointer" onClick={() => setShowReply(false)} />
                        <span className="B2-Medium m-l-10">Back To Comments</span>
                      </>
                    ) : (
                      <>
                        <ToggleButton /> <span className="B2-Medium m-l-10">Unread Replies</span>
                      </>
                    )}
                  </div>
                </div>
                {!showReply ? (
                  <div className="list-comments">
                    <section className="fg-single-comment">
                      <div className="align-center">
                        <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
                        <div className="B2-SemiBold"> Mark</div>
                        <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                        <div className="C1-Medium fg-text-gray-light"> 2m ago</div>
                        <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                        <img alt="" src={iPin} width={12} height={12} className="m-r-2" />
                        <div className="C1-Medium fg-text-gray-light"> 1:35</div>
                      </div>
                      <div className="m-t-4 m-l-32 m-b-6 B3-Regular">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto dicta in, sit tempore, maiores consequuntur laborum sunt
                        voluptates a officia veniam vel omnis commodi, dignissimos temporibus nihil delectus dolor rerum illum facere inventore? Iste,
                        labore. Illo quibusdam autem ea, officia dolorem rem aut.
                      </div>
                      <div className="m-l-32 align-center">
                        <img alt="" src={iReply} width={16} height={16} />
                        <span className="m-lr-6 B3-Medium pointer" onClick={() => setShowReply(true)}>
                          View 14 Replies
                        </span>
                        <img alt="" src={iCircleBlue} width={8} height={8} />
                      </div>
                    </section>
                    <section className="fg-single-comment">
                      <div className="align-center">
                        <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
                        <div className="B2-SemiBold"> Mark</div>
                        <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                        <div className="C1-Medium fg-text-gray-light"> 2m ago</div>
                        <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                        <img alt="" src={iPin} width={12} height={12} className="m-r-2" />
                        <div className="C1-Medium fg-text-gray-light"> 1:35</div>
                      </div>
                      <div className="m-t-4 m-l-32 m-b-6 B3-Regular">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto dicta in, sit tempore, maiores consequuntur laborum sunt
                        voluptates a officia veniam vel omnis commodi, dignissimos temporibus nihil delectus dolor rerum illum facere inventore? Iste,
                        labore. Illo quibusdam autem ea, officia dolorem rem aut.
                      </div>
                      <div className="m-l-32 align-center">
                        <img alt="" src={iReply} width={16} height={16} />
                        <span className="m-lr-6 B3-Medium pointer" onClick={() => setShowReply(true)}>
                          View 10 Replies
                        </span>
                        <img alt="" src={iCircleBlue} width={8} height={8} />
                      </div>
                    </section>
                    <div className="button button-md button-r button-gr">More Comments</div>
                  </div>
                ) : (
                  <div>
                    <div className="fg-single-comment">
                      <div className="align-center">
                        <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
                        <div className="B2-SemiBold"> Mark</div>
                        <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                        <div className="C1-Medium fg-text-gray-light"> 2m ago</div>
                        <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                        <img alt="" src={iPin} width={12} height={12} className="m-r-2" />
                        <div className="C1-Medium fg-text-gray-light"> 1:35</div>
                      </div>
                      <div className="m-t-4 m-l-32 m-b-6 B3-Regular">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto dicta in, sit tempore, maiores consequuntur laborum sunt
                        voluptates a officia veniam vel omnis commodi, dignissimos temporibus nihil delectus dolor rerum illum facere inventore? Iste,
                        labore. Illo quibusdam autem ea, officia dolorem rem aut.
                      </div>
                    </div>
                    <div className="countReplys">
                      <span className="B3-Medium m-lr-12"> 15 Replies </span>
                    </div>
                    <div className="show-replys">
                      <section className="fg-single-comment">
                        <div className="align-center">
                          <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
                          <div className="B2-SemiBold"> Mark</div>
                          <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                          <div className="C1-Medium fg-text-gray-light"> 2m ago</div>
                        </div>
                        <div className="m-t-4 m-l-32 m-b-6 B3-Regular">
                          Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1 Reply1
                        </div>
                      </section>
                      <section className="fg-single-comment">
                        <div className="align-center">
                          <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
                          <div className="B2-SemiBold"> Mark</div>
                          <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
                          <div className="C1-Medium fg-text-gray-light"> 2m ago</div>
                        </div>
                        <div className="m-t-4 m-l-32 m-b-6 B3-Regular">
                          Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2 Reply2
                          Reply2 Reply2 Reply2 Reply2 Reply2
                        </div>
                      </section>

                      <div className="button button-md button-r button-gr">More Replys</div>
                    </div>
                  </div>
                )}
              </>
            )}

            {/* {tab === "media" && (
            <div className="tab-body-content">
              <div className="tab-body__upload-box">
                <div className="tab-body__text-box">
                  <span>RECENT UPLOADS</span>
                  <div
                    className={`tab-body__sort-box ${
                      mediaUploadedItems.length === 0 && "visibility-hidden"
                    }`}
                    onClick={() => {
                      setIsUpSortable(!isUpSortable);
                      var a = [];
                      for (
                        let index = mediaUploadedItems.length - 1;
                        index >= 0;
                        index--
                      ) {
                        a.push({
                          id: mediaUploadedItems[
                            mediaUploadedItems.length - 1 - index
                          ]?.id,
                          os: mediaUploadedItems[index]?.os,
                          name: mediaUploadedItems[index]?.name,
                          type: mediaUploadedItems[index]?.type,
                          file: mediaUploadedItems[index]?.file,
                        });
                      }
                      setMediaUploadedItems(a);
                    }}
                  >
                    <SortUp
                      width={20}
                      height={20}
                      color={isUpSortable ? "#000" : "#c1d2e4"}
                      style={{ position: "absolute", top: "-14px" }}
                    />
                    <SortDown
                      width={20}
                      height={20}
                      color={isUpSortable ? "#c1d2e4" : "#000"}
                      style={{ position: "absolute", bottom: "-14px" }}
                    />
                  </div>
                </div>

                <Droppable
                  droppableId="media-section"
                  direction="vertical"
                  isDropDisabled={true}
                >
                  {(provided, snapshot) => {
                    return (
                      <div
                        className="tab-body__uploaded-items-box"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {mediaUploadedItems.map((i, index) => (
                          <div
                            key={index}
                            className="tab-body__uploaded-item-box"
                          >
                            <div className="tab-body__logo-and-text-box">
                              <Draggable
                                key={index}
                                draggableId={`${i.id}`}
                                index={index}
                                style={{ width: 80 }}
                              >
                                {(provided, snapshot) => {
                                  return (
                                    <div>
                                      <div
                                        className="tab-body__image-box"
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        ref={provided.innerRef}
                                      >
                                        {handelTumbnail(i)}
                                        <img alt=""
                                          src={handelLogoType(i.type)}
                                          width={13}
                                          className="tab-body__logo-type"
                                        />
                                      </div>
                                      {snapshot.isDragging && (
                                        <div className="tab-body__image-box">
                                          {handelTumbnail(i)}
                                          <img alt=""
                                            src={handelLogoType(i.type)}
                                            width={13}
                                            className="tab-body__logo-type"
                                          />
                                        </div>
                                      )}
                                    </div>
                                  );
                                }}
                              </Draggable>

                              <span className="tab-body__logo-and-text-box--text">
                                {handelTitle(i.name)}
                              </span>
                            </div>
                            <img alt=""
                              src={"/images/side-menu/Close.svg"}
                              width={15}
                              style={{ cursor: "pointer", zIndex: 4 }}
                              onClick={() => {
                                const index = mediaUploadedItems.findIndex(
                                  (j) => j.id === i.id
                                );
                                if (index !== -1) {
                                  var arr = [...mediaUploadedItems];
                                  arr.splice(index, 1);
                                  setMediaUploadedItems(arr);
                                }
                              }}
                            />
                          </div>
                        ))}
                        {provided.placeholder}
                      </div>
                    );
                  }}
                </Droppable>

                <div
                  className="tab-body__upload-box-btn"
                  onClick={() => InputRef.current.click()}
                >
                  <div className="upload-box__btn">
                    <div className="upload-box__logo">
                      <img alt=""
                        src={"/images/side-menu/Upload_logo.svg"}
                        width={16}
                      />
                    </div>
                    <div className="upload-box__content">
                      <span className="upload-box__btn--title">
                        Upload a File
                      </span>
                      <span className="upload-box__btn--subtitle">
                        Choose a file or Drag it Here
                      </span>
                    </div>
                  </div>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handelUploadMedia}
                    accept="audio/*,video/*,image/*"
                    ref={InputRef}
                  />
                </div>
              </div>
            </div>
          )} */}
          </div>
        )}
      </div>
    </div>
  );
}
